export default __webpack_public_path__ + "static/media/sort-arrow-up-inactive.677b34a5.svg";